<!-- On vérifie que le rootForm existe avant de créer les champs liés -->
<div *ngIf="rootForm && lieuxSad && ! (modeRenduService.enModeImpression$ | async)">
  <div class="form-row mx-2 pb-3" *ngIf="rootForm && lieuxSad">
    <div class="col" [formGroup]="rootForm">
      <div>
      <mat-accordion class=" col-12">
        <div *ngFor="let item of lieuxSad.controls; let i = index">
          <mat-expansion-panel (opened)="setStep(i)">
            <mat-expansion-panel-header>
              <mat-panel-description>
                <mat-icon>account_circle</mat-icon>&#xA0;
                <span [ngClass]="{'onglet-invalide': lieuxSad.controls[i].invalid}">
                  Informations sur le SAD {{ i + 1 }}
                </span>
                <button *ngIf="(modeRenduService.enModeSaisie$ | async)" (click)="supprimerLieuxSad(i)" class="btn-danger btn-sm ml-auto"
                  title="Supprimer le SAD">
                  <i class="material-icons md-18">delete</i>
                </button>
              </mat-panel-description>
            </mat-expansion-panel-header>
            <div class="form-row">
                <div class="col-md-8">
                   <!--<bis-filtered-select-input-keypad [preId]="i" [rootForm]="lieuxSad.controls[i]" 
                      nbChoixVisiblePossible="5" label="aaLieuSadCodCom" nomNomenclature="commune">
                   </bis-filtered-select-input-keypad>-->
                   <bis-commune-input-keypad [rootForm]="lieuxSad.controls[i]" [preId]="i" nbChoixVisiblePossible=10
                      label="aaLieuSadCodCom" nomNomenclature="commune">
                   </bis-commune-input-keypad>
                 </div>
                 <div class="col-md-4">
                   <bis-filtered-select-input-keypad [preId]="i" [rootForm]="lieuxSad.controls[i]" 
                   infoBulle="Préciser dans le menu déroulant si le lieu de permanence est en quartier prioritaire" label="aaLieuSadQp" nomNomenclature="ouiNonNsp">
                   </bis-filtered-select-input-keypad>
                 </div>
            </div>
            <div class="form-row">
                <div class="col-md-1"></div>
                <div class="col-md-10">
                   <bis-integer-inline-input-keypad [preId]="i" [rootForm]="lieuxSad.controls[i]" classeColLabel="col-8" classeColInput="col-2" classeSupplInput="text-right" 
                   label="aaLieuSadNbPerm" [max]="999" infoBulle="1 demi-journée = 3h" [erreursCroisees]="['ctrlA70Sad']">
                   </bis-integer-inline-input-keypad>
                   <bis-affiche-erreurs-croisees [rootForm]="lieuxSad.controls[i]" colorErreur="danger"
                     labelErreur="ctrlA70Sad">
                  </bis-affiche-erreurs-croisees>
                 </div>
            </div>
            <div class="form-row">
                 <div class="col-md-1"></div>
                 <div class="col-md-10">
                    <bis-integer-inline-input-keypad [preId]="i" [rootForm]="lieuxSad.controls[i]" classeColLabel="col-8" 
                    classeColInput="col-2" classeSupplInput="text-right" label="aaLieuSadNbPermEtp" [max]="9999" [erreursCroisees]="['ctrlA71Sad']"
                    infoBulle="3 personnes présentes sur une demi-journée = 3 demi-journées travaillées">
                    </bis-integer-inline-input-keypad>
                    <bis-affiche-erreurs-croisees [rootForm]="lieuxSad.controls[i]" colorErreur="danger"
                      labelErreur="ctrlA71Sad">
                    </bis-affiche-erreurs-croisees>
                    <bis-affiche-alertes [labelAlerte]="'alertA49Sad_' + i"></bis-affiche-alertes>
                 </div>
            </div>
            <div class="form-row">
                <div class="col-md-1"></div>
                <div class="col-md-10">
                   <bis-integer-inline-input-keypad [preId]="i" [rootForm]="lieuxSad.controls[i]" classeColLabel="col-8" classeColInput="col-2" classeSupplInput="text-right" 
                   label="aaLieuSadNbVict" [max]="99999" infoBulle="(physiques et morales)">
                   </bis-integer-inline-input-keypad>
                </div>
           </div>
        </mat-expansion-panel>
        </div>
        </mat-accordion>

        <button *ngIf="modeRenduService.enModeSaisie$ | async" class="mt-4 ml-n1 btn btn-info"
        (click)="ajouterLieuxSad()">Ajouter un Service d'accès au droit</button>

        <div class="form-row mt-4">
            <div class="col-md-6">
              <bis-integer-inline-input [rootForm]="formulaire" label="aaLieuSadNb" [max]="99" enLectureSeule="true"
                classeColLabel="col-6" classeColInput="col-4"      
                infoBulle="Cette zone est calculée automatiquement à partir du nombre de sad ajouté(s)">
              </bis-integer-inline-input>
          </div>
          <div class="col-md-6">
              <bis-integer-inline-input [rootForm]="formulaire" label="aaLieuSadNbPermTot" [max]="9999" enLectureSeule="true"
                classeColLabel="col-6" classeColInput="col-4">
              </bis-integer-inline-input>
          </div>
        </div>
        <div class="form-row">
          <div class="col-md-10">
              <bis-integer-inline-input [rootForm]="formulaire" label="aaLieuSadNbPermEtpTot" [max]="99999" 
                enLectureSeule="true" classeColLabel="col-6" classeColInput="col-4">
              </bis-integer-inline-input>
          </div>
        </div>
        <div class="form-row">
          <div class="col-md-10">
              <bis-integer-inline-input [rootForm]="formulaire" label="aaLieuSadNbVictTot" [max]="999999" 
                  enLectureSeule="true" classeColLabel="col-6" classeColInput="col-4">
              </bis-integer-inline-input>
          </div>
        </div>  
      </div>
    </div>
  </div>
</div>


<div *ngIf="rootForm && lieuxSad && (modeRenduService.enModeImpression$ | async)">
  <div class="form-row mx-2 pb-3" *ngIf="rootForm && lieuxSad">
    <div class="col" [formGroup]="rootForm">
      <div>
        <div *ngFor="let item of lieuxSad.controls; let i = index">
            <div class="form-row">
                <div class="col-md-8">
                   <!--<bis-filtered-select-input-keypad [preId]="i" [rootForm]="lieuxSad.controls[i]" 
                      nbChoixVisiblePossible="5" label="aaLieuSadCodCom" nomNomenclature="commune">
                   </bis-filtered-select-input-keypad>-->
                   <bis-commune-input-keypad [rootForm]="lieuxSad.controls[i]" [preId]="i" nbChoixVisiblePossible=10
                      label="aaLieuSadCodCom" nomNomenclature="commune">
                   </bis-commune-input-keypad>
                 </div>
                 <div class="col-md-4">
                   <bis-filtered-select-input-keypad [preId]="i" [rootForm]="lieuxSad.controls[i]" 
                   infoBulle="Préciser dans le menu déroulant si le lieu de permanence est en quartier prioritaire" label="aaLieuSadQp" nomNomenclature="ouiNonNsp">
                   </bis-filtered-select-input-keypad>
                 </div>
            </div>
            <div class="form-row">
                <div class="col-md-1"></div>
                <div class="col-md-10">
                   <bis-integer-inline-input-keypad [preId]="i" [rootForm]="lieuxSad.controls[i]" classeColLabel="col-8" classeColInput="col-2" classeSupplInput="text-right" 
                   label="aaLieuSadNbPerm" [max]="999" infoBulle="1 demi-journée = 3h" [erreursCroisees]="['ctrlA70Sad']">
                   </bis-integer-inline-input-keypad>
                   <bis-affiche-erreurs-croisees [rootForm]="lieuxSad.controls[i]" colorErreur="danger"
                     labelErreur="ctrlA70Sad">
                  </bis-affiche-erreurs-croisees>
                 </div>
            </div>
            <div class="form-row">
                 <div class="col-md-1"></div>
                 <div class="col-md-10">
                    <bis-integer-inline-input-keypad [preId]="i" [rootForm]="lieuxSad.controls[i]" classeColLabel="col-8" 
                    classeColInput="col-2" classeSupplInput="text-right" label="aaLieuSadNbPermEtp" [max]="9999" [erreursCroisees]="['ctrlA71Sad']"
                    infoBulle="3 personnes présentes sur une demi-journée = 3 demi-journées travaillées">
                    </bis-integer-inline-input-keypad>
                    <bis-affiche-erreurs-croisees [rootForm]="lieuxSad.controls[i]" colorErreur="danger"
                      labelErreur="ctrlA71Sad">
                    </bis-affiche-erreurs-croisees>
                    <bis-affiche-alertes [labelAlerte]="'alertA49Sad_' + i"></bis-affiche-alertes>
                 </div>
            </div>
            <div class="form-row">
                <div class="col-md-1"></div>
                <div class="col-md-10">
                   <bis-integer-inline-input-keypad [preId]="i" [rootForm]="lieuxSad.controls[i]" classeColLabel="col-8" classeColInput="col-2" classeSupplInput="text-right" 
                   label="aaLieuSadNbVict" [max]="99999" infoBulle="(physiques et morales)">
                   </bis-integer-inline-input-keypad>
                </div>
           </div>
        </div>
        <div class="form-row mt-4">
            <div class="col-md-6">
              <bis-integer-inline-input [rootForm]="formulaire" label="aaLieuSadNb" [max]="99" enLectureSeule="true"
                classeColLabel="col-6" classeColInput="col-4"      
                infoBulle="Cette zone est calculée automatiquement à partir du nombre de sad ajouté(s)">
              </bis-integer-inline-input>
          </div>
          <div class="col-md-6">
              <bis-integer-inline-input [rootForm]="formulaire" label="aaLieuSadNbPermTot" [max]="9999" enLectureSeule="true"
                classeColLabel="col-6" classeColInput="col-4">
              </bis-integer-inline-input>
          </div>
        </div>
        <div class="form-row">
          <div class="col-md-10">
              <bis-integer-inline-input [rootForm]="formulaire" label="aaLieuSadNbPermEtpTot" [max]="99999" 
                enLectureSeule="true" classeColLabel="col-6" classeColInput="col-4">
              </bis-integer-inline-input>
          </div>
        </div>
        <div class="form-row">
          <div class="col-md-10">
              <bis-integer-inline-input [rootForm]="formulaire" label="aaLieuSadNbVictTot" [max]="999999" 
                  enLectureSeule="true" classeColLabel="col-6" classeColInput="col-4">
              </bis-integer-inline-input>
          </div>
        </div>  
      </div>
    </div>
  </div>
</div>